import Vue from "vue";
import Vuex from "vuex";
import Authentication from "../auth";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    loggedIn: false,
    inMemoryToken: undefined,
    idleFrom: undefined,
    didSetMfa: false,
    didSetPassword: false,
    userDetails: {},
    workSpace: {},
    newUser: false,
    forceMFA: false,
    forcePasswordReset: false,
  },
  mutations: {
    login(state, value) {
      state.loggedIn = value;
    },
    setToken(state, value) {
      state.inMemoryToken = value;
    },
    setIdleFrom(state, value) {
      state.idleFrom = value;
    },
    setDidChangeMfa(state, value) {
      state.didSetMfa = value;
    },
    setDidChangePassword(state, value) {
      state.didSetPassword = value;
    },
    setUserDetails(state, value) {
      state.userDetails = value;
    },
    setWorkSpace(state, value) {
      state.workSpace = value;
    },
    setNewUser(state, value) {
      state.newUser = value;
    },
    setFlags(state, value) {
      state.flags = value;
    },
    setForceMFA(state, value) {
      state.forceMFA = value;
    },
    setForcePasswordReset(state, value) {
      state.forcePasswordReset = value;
    },
  },
  actions: {
    async checkIfLoggedIn({ commit }) {
      const loggedIn = Authentication.isLoggedIn();
      if (loggedIn) {
        const username = Authentication.getUser().cn;

        commit("login", username);
        return true;
      } else {
        commit("login", false);
        return false;
      }
    },
    async logout({ commit }) {
      commit("login", false);
      Authentication.logout();
    },
    async userDetails({ commit }) {
      const userdetails = await Authentication.fetch(
        "api/activedir/userdetails",
        "GET"
      );

      commit("setUserDetails", userdetails);
    },
    async getUser() {
      return await Authentication.getUser();
    },
    async flags() {
      const user = await Authentication.getUser();
      return user.flags;
    },
    async isHEEnv() {
      return (await Authentication.getUser()).sAMAccountName
        .toLowerCase()
        .match(/.+adm$/g);
    },
    async getWorkSpace({ commit, dispatch }) {
      const isHEWorkspace = await dispatch("isHEEnv");
      const workspaces = await Authentication.fetchGET("/api/ws/describe", {
        environment: isHEWorkspace ? "PROD" : "DEV",
      });

      console.log(workspaces);
      if (workspaces && workspaces[0]) {
        commit("setWorkSpace", workspaces[0]);
        return workspaces[0];
      }
    },
  },
  modules: {},
});
